const state = {
    selected_tree: null
}

const mutations = {
    updateSelectedTree: (state, payload) => {
        state.selected_tree = payload.selected_tree;
    },
}

const actions = {
    asyncUpdateSelectedTree ( {commit}, payload ) {
        commit('updateSelectedTree', payload)
    },
}

const getters = {
    selected_tree: state => {
        return state.selected_tree
    },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
